export function resetLocalStorage(stage = "ALL") {
  if (stage === "ALL") {
    if (window) {
      window.localStorage.clear();
    }
  }
  if (stage === "TRIP_CREATE" || stage === "CHECKIN_START" || stage === "MANAGE_BOOKING") {
    localStorage.removeItem("addedSsrKey");
    localStorage.removeItem("baggageSsr");
    localStorage.removeItem("baggageFare");

    localStorage.removeItem("priorityBoardFare");
    localStorage.removeItem("priorityBoardingSsr");

    localStorage.removeItem("prioritySsr");
    localStorage.removeItem("priorityFare");

    localStorage.removeItem("delaySsr");
    localStorage.removeItem("delayFare");
    localStorage.removeItem("tracelSsr");
    localStorage.removeItem("travelFare");
    localStorage.removeItem("loungeSsr");
    localStorage.removeItem("loungeFare");
    localStorage.removeItem("cancelSsr");
    localStorage.removeItem("cancelFare");
    localStorage.removeItem("userDetails");
    localStorage.removeItem("segmentDetails");
    localStorage.removeItem("selectedPassengers");
    localStorage.removeItem("legDetails");
    localStorage.removeItem("oneWayUser");
    localStorage.removeItem("returnUser");
    localStorage.removeItem("journeyDetailsSel");
    localStorage.removeItem("baggageFare");
  }
}
